import { PaymentTab } from './PaymentTab';

export default PaymentTab;